import i18next from 'i18next';
import { features } from "../../utils/enums";

// Helper function to get translations using global i18next from config namespace
const tGenerics = (key, defaultValue = '') => {
  try {
    // Use config namespace for route-related translations
    return i18next.isInitialized ? i18next.t(key, { ns: 'generics', defaultValue }) : defaultValue;
  } catch (error) {
    console.warn(`Translation key "${key}" not found in config namespace`);
    return defaultValue;
  }
};

/**
 * Builds one time-filter config entry from a shared translation prefix.
 * The optional `feature` key marks filters that should be gated by the
 * overlay feature payload before they are shown/enabled in the dropdown.
 */
const createTimeFilterOption = (
  value,
  translationPrefix,
  { feature } = {}
) => ({
  get label() { return tGenerics(translationPrefix); },
  value,
  get text() { return tGenerics(`${translationPrefix}Text`); },
  get legendText() { return tGenerics(`${translationPrefix}Legend`); },
  get toolTip() { return tGenerics(`${translationPrefix}Tooltip`); },
  ...(feature ? { feature } : {})
});

const timeFilterConfig = {
  "1": createTimeFilterOption("1", "timeFilter1Hour"),
  "3": createTimeFilterOption("3", "timeFilter3Hours"),
  "6": createTimeFilterOption("6", "timeFilter6Hours"),
  "12": createTimeFilterOption("12", "timeFilter12Hours"),
  "24": createTimeFilterOption("24", "timeFilter24Hours", {
    feature: features.days1
  }),
  "168": createTimeFilterOption("168", "timeFilter7Days", {
    feature: features.days7
  }),
  "720": createTimeFilterOption("720", "timeFilter1Month", {
    feature: features.days30
  }),
  "Custom": createTimeFilterOption("Custom", "timeFilterCustom", {
    feature: features.custom
  })
};

export const datePickerDefaultprops = {
  width: "calc(var(--hbr-spacing-md)*8.5)",
  hoist: true,
  required: true,
  showDaysInNextAndPreviousMonths: true,
  variant: "outline",
  outlineLabel: "Label",
  calendarStyle: "square",
  placeholder: [tGenerics('startDate'), tGenerics('endDate')],
  i18n: {
    weekdaysShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ]
  }
};

export default timeFilterConfig;
